import { apiRequest } from './client.js';

export interface AuthUser {
  id: string;
  email: string;
  role: 'auditor' | 'admin' | 'super_admin';
}

export interface LoginResponse {
  kind: 'temp';
  token: string;
  expires_at: string;
  mfa_status: 'setup_required' | 'configured';
}

export interface MfaSetupResponse {
  otpauth_url: string;
  qr_data_url: string;
  recovery_codes: string[];
  expires_in_seconds: number;
}

export interface FullAuthResponse {
  kind: 'full';
  token: string;
  expires_at: string;
  user: AuthUser;
}

export interface MeResponse {
  user: AuthUser & { isActive: boolean; lastLoginAt: string | null };
  jwt: { jti: string; expires_at: string };
}

export const authApi = {
  login: (email: string, password: string) =>
    apiRequest<LoginResponse>('/api/auth/login', {
      method: 'POST',
      body: { email, password },
      signalAuthErrors: false,
    }),

  mfaSetupBegin: () => apiRequest<MfaSetupResponse>('/api/auth/mfa/setup', { method: 'POST' }),

  mfaSetupConfirm: (code: string) =>
    apiRequest<FullAuthResponse>('/api/auth/mfa/setup/confirm', {
      method: 'POST',
      body: { code },
    }),

  mfaVerify: (code: string) =>
    apiRequest<FullAuthResponse>('/api/auth/mfa/verify', {
      method: 'POST',
      body: { code },
    }),

  logout: () => apiRequest<void>('/api/auth/logout', { method: 'POST' }),

  me: () => apiRequest<MeResponse>('/api/auth/me'),
};
